import { Moment } from 'moment';
const urlSafeBase64 = require('urlsafe-base64');
const getUrl = require('bmh/url-with-param');
const getSuffix = require('bmh/get-suffix');

export function date(data?: Moment): string {
  if (!data) {
    return '';
  }
  return data.format('YYYY-MM-DD');
}

export function time(data?: Moment): string {
  if (!data) {
    return '';
  }
  return data.format('HH:mm:ss');
}

export function dateTime(data?: Moment): string {
  if (!data) {
    return '';
  }
  return data.format('YYYY-MM-DD HH:mm:ss');
}

export function simpleArrayOptions(array: any[]): SelectOption[] {
  return array.map((item: any) => ({ label: item, value: item }));
}

export function imageUrlWithWatermark(url: string, watermarkText: string): string {
  return getUrl(url, {
    'x-oss-process': `image/format,jpg/watermark,text_${urlSafeBase64.encode(watermarkText)},color_ffffff`
  });
}

// handle webp
export function imgUrl(url: string): string {
  const suffix = getSuffix(url).substr(1) || '';
  if (!suffix || ['jpeg', 'jpg', 'png'].indexOf(suffix.toLowerCase()) > -1) {
    return url;
  }
  return getUrl(url, { 'x-oss-process': 'image/format,jpg' });
}
